import { IconButton, Row } from "@narmi/design_system";
import styles from "./style.module.css";
import { SavedReply } from "@pages/configuration/messages/types";

export function SavedReplyPreview({
  savedReply,
  onAccept,
  onDismiss,
  disabled = false,
}: {
  savedReply: SavedReply;
  onAccept: () => void;
  onDismiss: () => void;
  disabled?: boolean;
}) {
  return (
    <div className={`${styles.savedReplyPreview} ${styles.replyPreview}`}>
      <div className="padding--y--s">
        <div className="margin--left--l margin--bottom--l">
          <Row alignItems="center" gapSize="xs">
            <Row.Item>
              <div className="fontWeight--semibold">Saved reply: {savedReply.name}</div>
            </Row.Item>
            <Row.Item shrink>
              <IconButton
                kind="action"
                name="x"
                onClick={onDismiss}
                textSize="l"
                disabled={disabled}
              />
            </Row.Item>
            <Row.Item shrink>
              <IconButton
                kind="action"
                name="check"
                onClick={onAccept}
                textSize="l"
                disabled={disabled}
              />
            </Row.Item>
          </Row>
        </div>
        <div>
          <pre className={styles.previewBody}>{savedReply.body}</pre>
        </div>
      </div>
    </div>
  );
}
